module.exports = __webpack_public_path__ + "img/banner_left.5d2ea6a3.png";